module.exports = __webpack_public_path__ + "/6a812413c6343cc64cc499ee02778b2f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/signature-modal/sigcreation_modal_rotate_clockwise_@2x.png
 ** module id = 693
 ** module chunks = 0
 **/